module.exports = __webpack_public_path__ + "08f27920b633d2c03ecfcc5a8359d9d0.fbx";